import { integerFormatter } from "../../gridFormatters";

export const backupGapAnalysis = [
    {
        "field": "resource",
        "headerName": "Resource",
        "cellRenderer": params => {
            if(params.value?.[0] === 'k') {
                return params.value.slice(1)
            } else {
                return params.value
            };
        }
    },
    {
        "field": "device_name",
        "headerName": "Backup Device"
    },
    {
        "field": "total",
        "headerName": "Total",
        "aggFunc": "sum",
      	"type": "numericColumn",
        "cellRenderer": integerFormatter
    },
    {
        "field": "protection_configured",
        "headerName": "Protection Configured",
        "aggFunc": "sum",
      	"type": "numericColumn",
        "cellRenderer": integerFormatter
    },
    {
        "field": "successful",
        "headerName": "Successful",
        "aggFunc": "sum",
      	"type": "numericColumn",
        "cellRenderer": integerFormatter
    },
    {
        "field": "incomplete",
        "headerName": "Incomplete",
        "aggFunc": "sum",
      	"type": "numericColumn",
        "cellRenderer": integerFormatter
    },
    {
        "field": "unprotected",
        "headerName": "Unprotected",
        "aggFunc": "sum",
      	"type": "numericColumn",
        "cellRenderer": integerFormatter
    },
];